import React from "react";
import { PRODUCTS_MENU_LINKS } from "./constants";
import Image from "next/image";
import Link from "next/link";
import { env } from "@/config/env";
import { Icon } from "../Icon";

export default function ProductsMenu() {
  return (
    <div className="px-12 pt-4 pb-4 xl:w-[1200px] lg:w-[1000px]">
      <div className="flex gap-12">
        <div className="flex flex-col items-start w-2/5">
          <div className="flex gap-2 flex-col">
            <p className="text-xl font-bold text-[#12074D] ">
              <span className="text-primary-900 hover:text-secondary-900">
                Mintology
              </span>{" "}
              for Service
            </p>
            <p className="">One-stop NFT solutions for businesses</p>
          </div>
          <div className="rounded-lg overflow-hidden mt-10">
            <Image
              src="/images/products/menu-image.png"
              alt="products-sample-image"
              height={100}
              width={400}
              className="object-contain "
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {PRODUCTS_MENU_LINKS.map((menu) => (
            <Link
              key={menu.title}
              href={menu.url}
              className="group flex gap-8 justify-between border rounded-xl border-primary-400 px-4 py-4 h-[100px] bg-primary-100 hover:bg-gradient-to-r hover:from-[#7E37F1] hover:to-[#483CD4] hover:cursor-pointer hover:text-white"
            >
              <div className="w-8 h-8 flex items-center justify-center">
                {menu.icon}
              </div>

              <div className="flex flex-col justify-between flex-1">
                <p className="text-md font-semibold">{menu.title}</p>
                <div className="flex justify-between items-center gap-2">
                  <p className="text-xs">{menu.description}</p>
                  {/* Arrow Icon */}
                  <div className="w-5 h-5 transform scale-0 opacity-0 group-hover:scale-100 group-hover:opacity-100 transition-all duration-200 origin-center text-gray-900 group-hover:text-white">
                    <Icon name="arrow-right" size="md" />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <div className="flex justify-between border-t-2 border-gray-100 py-4 mt-4">
        {" "}
        <Link
          href={env.MINTABLE_URL}
          className=" flex gap-2 items-center hover:cursor-pointer"
        >
          {" "}
          <Image
            alt="Mintable Logo"
            height={40}
            src="/images/mintable-full-logo.svg"
            width={120}
          />
          <Image
            alt="External Link Icon"
            height={20}
            src="/images/external-link.svg"
            width={25}
          />
        </Link>
        <div className="flex gap-4 items-center">
          <Link href={env.DASHBOARD_LOG_IN_URL} className="flex gap-2">
            <span>Get started</span> <Icon name="right-arrow" />
          </Link>
          <Link href="/contact">Contact sales</Link>
        </div>
      </div>
    </div>
  );
}
